var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00845 7.96667C6.51416 5.58308 9.17218 4 12.2 4C15.2277 4 17.8857 5.58308 19.3914 7.96667M19.3914 17.0333C17.8857 19.4169 15.2277 21 12.2 21C9.17218 21 6.51416 19.4169 5.00845 17.0333M21.2667 10.8L22.4 10.2334M2 10.8L3.13334 10.2334M21.2667 14.2L22.4 14.7666M2 14.2L3.13333 14.7666",
    stroke: "url(#paint0_linear_1673_22690)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74842 10.6777H5.43242C5.32196 10.6777 5.23242 10.7673 5.23242 10.8777V14.6671C5.23242 14.7775 5.32197 14.8671 5.43242 14.8671H5.73676C5.84721 14.8671 5.93676 14.7775 5.93676 14.6671V13.1217H7.61242C7.72288 13.1217 7.81242 13.0322 7.81242 12.9217V12.6627C7.81242 12.5523 7.72288 12.4627 7.61242 12.4627H5.93676V11.3424L7.74842 11.3424C7.85888 11.3424 7.94842 11.2529 7.94842 11.1424V10.8777C7.94842 10.7673 7.85888 10.6777 7.74842 10.6777Z",
    fill: "url(#paint1_linear_1673_22690)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.47 14.5556L10.5936 13.2504L10.5939 13.248C10.5949 13.2449 10.5975 13.2419 10.6009 13.2403C11.1017 13.0121 11.3876 12.5155 11.3876 12.0187C11.3876 11.6736 11.2709 11.3375 11.032 11.087C10.792 10.8353 10.4359 10.6777 9.97293 10.6777H8.64493C8.53448 10.6777 8.44494 10.7673 8.44494 10.8777V14.6671C8.44494 14.7775 8.53448 14.8671 8.64493 14.8671H8.94927C9.05973 14.8671 9.14927 14.7775 9.14927 14.6671V13.3711H9.83475L10.784 14.7789C10.8211 14.834 10.8833 14.8671 10.9498 14.8671H11.304C11.464 14.8671 11.5593 14.6884 11.47 14.5556ZM9.9106 11.3367C10.1912 11.3367 10.3784 11.4183 10.4955 11.5366C10.613 11.6553 10.6719 11.8232 10.6719 12.0187C10.6719 12.2077 10.6121 12.3793 10.4925 12.5032C10.3738 12.626 10.1863 12.7121 9.9106 12.7121H9.14927V11.3367L9.9106 11.3367Z",
    fill: "url(#paint2_linear_1673_22690)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4504 10.6777H12.1231C12.0126 10.6777 11.9231 10.7673 11.9231 10.8777V14.6671C11.9231 14.7775 12.0126 14.8671 12.1231 14.8671H14.4504C14.5609 14.8671 14.6504 14.7775 14.6504 14.6671V14.4024C14.6504 14.2919 14.5609 14.2024 14.4504 14.2024H12.6274V13.0481L14.3427 13.0481C14.4532 13.0481 14.5427 12.9585 14.5427 12.8481V12.5891C14.5427 12.4786 14.4532 12.3891 14.3427 12.3891H12.6274V11.3424H14.4504C14.5609 11.3424 14.6504 11.2529 14.6504 11.1424V10.8777C14.6504 10.7673 14.5609 10.6777 14.4504 10.6777Z",
    fill: "url(#paint3_linear_1673_22690)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7017 10.6777H15.3743C15.2639 10.6777 15.1743 10.7673 15.1743 10.8777V14.6671C15.1743 14.7775 15.2639 14.8671 15.3743 14.8671H17.7017C17.8121 14.8671 17.9017 14.7775 17.9017 14.6671V14.4024C17.9017 14.2919 17.8121 14.2024 17.7017 14.2024H15.8787V13.0481L17.594 13.0481C17.7044 13.0481 17.794 12.9585 17.794 12.8481V12.5891C17.794 12.4786 17.7044 12.3891 17.594 12.3891H15.8787V11.3424H17.7017C17.8121 11.3424 17.9017 11.2529 17.9017 11.1424V10.8777C17.9017 10.7673 17.8121 10.6777 17.7017 10.6777Z",
    fill: "url(#paint4_linear_1673_22690)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2161 13.4795L19.2477 10.8802C19.249 10.7688 19.1591 10.6777 19.0477 10.6777H18.7231C18.6117 10.6777 18.5218 10.7688 18.5231 10.8802L18.5547 13.4795C18.556 13.589 18.6452 13.6771 18.7547 13.6771H19.0161C19.1256 13.6771 19.2148 13.589 19.2161 13.4795Z",
    fill: "url(#paint5_linear_1673_22690)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8882 14.0381C18.6436 14.0381 18.4369 14.227 18.4369 14.4837C18.4369 14.7405 18.6436 14.9294 18.8882 14.9294C19.1329 14.9294 19.3396 14.7405 19.3396 14.4837C19.3396 14.227 19.1329 14.0381 18.8882 14.0381Z",
    fill: "url(#paint6_linear_1673_22690)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1673_22690",
    x1: 15.354,
    y1: 2.9375,
    x2: 25.4999,
    y2: 18.0134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1673_22690",
    x1: 14.467,
    y1: 10.412,
    x2: 15.7258,
    y2: 15.5838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1673_22690",
    x1: 14.467,
    y1: 10.412,
    x2: 15.7258,
    y2: 15.5838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1673_22690",
    x1: 14.467,
    y1: 10.412,
    x2: 15.7258,
    y2: 15.5838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1673_22690",
    x1: 14.467,
    y1: 10.412,
    x2: 15.7258,
    y2: 15.5838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1673_22690",
    x1: 14.467,
    y1: 10.412,
    x2: 15.7258,
    y2: 15.5838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1673_22690",
    x1: 14.467,
    y1: 10.412,
    x2: 15.7258,
    y2: 15.5838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFree);
export default __webpack_public_path__ + "static/media/free.8b3b2359f6525375d30adef7580aa7fc.svg";
export { ForwardRef as ReactComponent };